/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import {
    EntityAttributeProps,
    EntityAttributeState,
    ENTITY_ATTRIBUTE_DEFAULT_PROPS,
    getEntityAttributeStateFromProps,
    EntityAttribute,
} from './EntityAttribute';

/**
 * Component for rendering an arbitrary entity attribute
 */
export class DefaultEntityAttribute extends EntityAttribute<
    EntityAttributeProps,
    EntityAttributeState
> {
    public static defaultProps = ENTITY_ATTRIBUTE_DEFAULT_PROPS;
    state: EntityAttributeState;
    timeout: number | undefined;
    _isMounted: boolean;

    constructor(props: Readonly<EntityAttributeProps>) {
        super(props);
        this.timeout = undefined;
        this._isMounted = false;
        this.state = getEntityAttributeStateFromProps(props);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        window.clearTimeout(this.timeout);
        this._isMounted = false;
    }

    componentDidUpdate(
        prevProps: EntityAttributeProps,
        prevState: EntityAttributeState,
        snapshot: any
    ) {
        if (this.props.entity !== prevProps.entity) {
            this.setState(getEntityAttributeStateFromProps(this.props));
        }
    }

    render(): JSX.Element {
        return this.props.render(this);
    }
}
